import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, Box, TextField,
} from '@material-ui/core';
import {
  setSaveConditionPopFlg,
  registerSearchCondition,
  setConditionName,
  setErrMsgConditionName,
  setCheckConditionName,
  setSaveConditionSuccessPopFlg,
  setDispConditionName,
} from '../../actions/TargetAction';
import validator from '../../../common/validator';
import { getMessage } from '../../../common/util';
import { ERROR } from '../../../common/message';
import { setInitMessage } from '../../actions/CommonAction';
import styles from './PopStyles.module.css';

class TargetPopSaveConditionsComponent extends Component {
  async componentDidMount() {
    const {
      setInitMessageAct,
      saveConditionPopFlg,
    } = this.props;

    if (saveConditionPopFlg) {
      setInitMessageAct();
    }
  }

  /**
  * 検索条件保存ポップアップを閉じる
  */
  closeSaveConditionPop = () => {
    const {
      setSaveConditionPopFlgAct,
      setConditionNameAct,
      setCheckConditionNameAct,
      setErrMsgConditionNameAct,
    } = this.props;

    setConditionNameAct();
    setErrMsgConditionNameAct();
    setCheckConditionNameAct(false);
    setSaveConditionPopFlgAct(false);
  };

  /**
  * 検索条件保存
  */
  saveClick = async () => {
    const {
      conditionName,
      registerSearchConditionAct,
      setErrMsgConditionNameAct,
      setSaveConditionSuccessPopFlgAct,
    } = this.props;
    const msgs = [];
    validator.checkRequired('検索条件名', conditionName, msgs);
    if (msgs.length !== 0) {
      setErrMsgConditionNameAct(msgs);
      return;
    }
    const ret = await registerSearchConditionAct();

    if (ret) {
      // ポップアップ表示処理
      setSaveConditionSuccessPopFlgAct(true);
    }
  }

  /**
  * 検索条件保存・成功ポップアップを閉じる
  */
  closeSaveConditionSuccessPop = () => {
    const {
      setSaveConditionSuccessPopFlgAct,
      conditionName,
      setDispConditionNameAct,
    } = this.props;

    setSaveConditionSuccessPopFlgAct(false);
    // 吹き出し用の検索条件名を設定
    setDispConditionNameAct(conditionName);
    this.closeSaveConditionPop();
  };

  /**
  * 検索条件名最大桁数のチェック
  */
  onBlurConditionName = () => {
    const {
      conditionName,
      setErrMsgConditionNameAct,
      setCheckConditionNameAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(conditionName, 50, msgs);

    if (msgs.length !== 0) {
      // エラーメッセージ有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgConditionNameAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckConditionNameAct(true);
      return;
    }

    setErrMsgConditionNameAct();
    setCheckConditionNameAct(false);
  }

  render() {
    const {
      saveConditionPopFlg,
      setConditionNameAct,
      conditionName,
      errMsgConditionName,
      checkErrFlg,
      saveConditionSuccessPopFlg,
    } = this.props;

    return (
      saveConditionPopFlg && (
        <Box className={`${styles.searchCondSave}`}>
          <Box className={`${styles.contents}`}>
            <Box className={`${styles.message}`}>
              保存する検索条件名（50文字まで）
            </Box>
            <Box className={`${styles.errorarea}`}>
              <span className={`${styles.errorBottom}`}>{errMsgConditionName}</span>
            </Box>

            <Box className={`${styles.inputarea}`}>
              <TextField
                className={`${styles.input} ${styles.marginbottom1}`}
                InputProps={{ classes: { input: styles.saveConditionTxt } }}
                onBlur={() => this.onBlurConditionName()}
                value={conditionName || ''}
                onChange={(ev) => setConditionNameAct(ev.target.value)}
                variant="outlined"
                error={errMsgConditionName}
              />
            </Box>
            <Box className={`${styles.buttonarea}`}>
              <Button
                variant="contained"
                className="cancel"
                onClick={() => this.closeSaveConditionPop()}
              >
                キャンセル
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => this.saveClick()}
                disabled={checkErrFlg.checkConditionName}
              >
                保存
              </Button>
            </Box>
          </Box>
          {saveConditionSuccessPopFlg && (
            <Box className={`${styles.bgContents}`}>
              <Box className={`${styles.saveSuccessContents}`}>
                <Box className={`${styles.saveSuccessMassage}`}>
                  検索条件の保存に成功しました。
                </Box>
                <Box className={`${styles.saveSuccessButton}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => this.closeSaveConditionSuccessPop()}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      ));
  }
}

export default connect(
  (state) => ({
    saveConditionPopFlg: state.target.saveConditionPopFlg,
    conditionName: state.target.conditionName,
    errMsgConditionName: state.target.errMsgConditionName,
    checkErrFlg: state.target.checkErrFlg,
    saveConditionSuccessPopFlg: state.target.saveConditionSuccessPopFlg,
  }),
  (dispatch) => ({
    setSaveConditionPopFlgAct: (bool) => dispatch(setSaveConditionPopFlg(bool)),
    registerSearchConditionAct: () => dispatch(registerSearchCondition()),
    setConditionNameAct: (string) => dispatch(setConditionName(string)),
    setErrMsgConditionNameAct: (string) => dispatch(setErrMsgConditionName(string)),
    setCheckConditionNameAct: (bool) => dispatch(setCheckConditionName(bool)),
    setSaveConditionSuccessPopFlgAct: (bool) => dispatch(setSaveConditionSuccessPopFlg(bool)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setDispConditionNameAct: (string) => dispatch(setDispConditionName(string)),
  }),
)(TargetPopSaveConditionsComponent);
